// This file is auto-generated by the generate:translations task. Do not edit directly.

enum AdminPortalKeys {
  Maintenance_Headline = 'adminPortal:maintenance.headline',
  Maintenance_Switch = 'adminPortal:maintenance.switch',
  BackToOverview = 'adminPortal:backToOverview',
  BackToList = 'adminPortal:backToList',
  ActivationMaintenancePageOverlay_Title = 'adminPortal:activationMaintenancePageOverlay.title',
  ActivationMaintenancePageOverlay_Description = 'adminPortal:activationMaintenancePageOverlay.description',
  ActivationMaintenancePageOverlay_BtnActivate = 'adminPortal:activationMaintenancePageOverlay.btnActivate',
  Navigation_Menu = 'adminPortal:navigation.menu',
  Navigation_Logout = 'adminPortal:navigation.logout',
  Navigation_Welcome = 'adminPortal:navigation.welcome',
  Navigation_Pharmacies = 'adminPortal:navigation.pharmacies',
  Navigation_Patients = 'adminPortal:navigation.patients',
  Navigation_Doctors = 'adminPortal:navigation.doctors',
  Navigation_OpenRequests = 'adminPortal:navigation.openRequests',
  Navigation_FailedRequests = 'adminPortal:navigation.failedRequests',
  Navigation_Promotions = 'adminPortal:navigation.promotions',
  Navigation_PickPost = 'adminPortal:navigation.pickPost',
  Navigation_PickPostView = 'adminPortal:navigation.pickPostView',
  Navigation_Maintenance = 'adminPortal:navigation.maintenance',
  Navigation_Profile = 'adminPortal:navigation.profile',
  Pagination_Label = 'adminPortal:pagination.label',
  Pagination_PreviousPage = 'adminPortal:pagination.previousPage',
  Pagination_NextPage = 'adminPortal:pagination.nextPage',
  Pagination_Loading = 'adminPortal:pagination.loading',
  Header_LogoAlt = 'adminPortal:header.logoAlt',
  Footer_Copyright = 'adminPortal:footer.copyright',
  Welcome_Headline = 'adminPortal:welcome.headline',
  Welcome_PickPostAdministration = 'adminPortal:welcome.pickPostAdministration',
  Welcome_PatientAdministration = 'adminPortal:welcome.patientAdministration',
  Welcome_DoctorsAdministration = 'adminPortal:welcome.doctorsAdministration',
  Promotions_PromotionCode = 'adminPortal:promotions.promotionCode',
  Promotions_PromotionName = 'adminPortal:promotions.promotionName',
  Promotions_PromotionValidFrom = 'adminPortal:promotions.promotionValidFrom',
  Promotions_PromotionValidUntil = 'adminPortal:promotions.promotionValidUntil',
  Promotions_PromotionFullfillUntil = 'adminPortal:promotions.promotionFullfillUntil',
  Promotions_MediaCode = 'adminPortal:promotions.mediaCode',
  Promotions_FilterActive = 'adminPortal:promotions.filterActive',
  Promotions_FilterComing = 'adminPortal:promotions.filterComing',
  Promotions_FilterExpired = 'adminPortal:promotions.filterExpired',
  Promotions_CreateNew = 'adminPortal:promotions.createNew',
  Promotions_NoResults = 'adminPortal:promotions.noResults',
  Promotions_NoResultsForFilter = 'adminPortal:promotions.noResultsForFilter',
  Promotions_LastExport = 'adminPortal:promotions.lastExport',
  Promotions_ExportButton = 'adminPortal:promotions.exportButton',
  Promotions_ExportConfirmText = 'adminPortal:promotions.exportConfirmText',
  Promotions_ExportConfirmButton = 'adminPortal:promotions.exportConfirmButton',
  Promotions_ExportNoData = 'adminPortal:promotions.exportNoData',
  Promotions_Headline = 'adminPortal:promotions.headline',
  Promotions_HeadlineCreate = 'adminPortal:promotions.headlineCreate',
  Promotions_LoadingDetail = 'adminPortal:promotions.loadingDetail',
  Promotions_NotFound = 'adminPortal:promotions.notFound',
  Promotions_ValidFromDate = 'adminPortal:promotions.validFromDate',
  Promotions_ValidFromTime = 'adminPortal:promotions.validFromTime',
  Promotions_ValidUntilDate = 'adminPortal:promotions.validUntilDate',
  Promotions_ValidUntilTime = 'adminPortal:promotions.validUntilTime',
  Promotions_FulfillUntilDate = 'adminPortal:promotions.fulfillUntilDate',
  Promotions_FulfillUntilTime = 'adminPortal:promotions.fulfillUntilTime',
  Promotions_VoucherValue = 'adminPortal:promotions.voucherValue',
  Promotions_ErrorCheckInput = 'adminPortal:promotions.errorCheckInput',
  Promotions_ActiveEditNotice = 'adminPortal:promotions.activeEditNotice',
  Promotions_ExpiredNotice = 'adminPortal:promotions.expiredNotice',
  Promotions_ValidFromNotInPast = 'adminPortal:promotions.validFromNotInPast',
  Promotions_ValidUntilAfterValidFrom = 'adminPortal:promotions.validUntilAfterValidFrom',
  Promotions_FulfillUntilAfterValidUntil = 'adminPortal:promotions.fulfillUntilAfterValidUntil',
  Promotions_Created = 'adminPortal:promotions.created',
  Welcome_PromotionAdministration = 'adminPortal:welcome.promotionAdministration',
  Profile_Headline = 'adminPortal:profile.headline',
  Login_Info = 'adminPortal:login.info',
  Login_GenericError = 'adminPortal:login.genericError',
  Login_FormHeadline = 'adminPortal:login.formHeadline',
  Login_LoginButton = 'adminPortal:login.loginButton',
  Login_ErrorEmptyForm = 'adminPortal:login.errorEmptyForm',
  Login_InvalidCredentials = 'adminPortal:login.invalidCredentials',
  Login_ServerError = 'adminPortal:login.serverError',
  Login_LogoutSuccess = 'adminPortal:login.logoutSuccess',
  Login_SessionTimeoutSuccess = 'adminPortal:login.sessionTimeoutSuccess',
  Login_PageClaim = 'adminPortal:login.pageClaim',
  Patients_InvalidCustomerId = 'adminPortal:patients.invalidCustomerId',
  Patients_InvalidEmail = 'adminPortal:patients.invalidEmail',
  Patients_InvalidUsername = 'adminPortal:patients.invalidUsername',
  Patients_InvalidCardId = 'adminPortal:patients.invalidCardId',
  Patients_FilterLean = 'adminPortal:patients.filterLean',
  Patients_FilterLeanMediplus = 'adminPortal:patients.filterLeanMediplus',
  Patients_FilterKpt = 'adminPortal:patients.filterKpt',
  Patients_FilterRx = 'adminPortal:patients.filterRx',
  Patients_Search = 'adminPortal:patients.search',
  Patients_CustomerType = 'adminPortal:patients.customerType',
  Patients_AccountTypePlatform = 'adminPortal:patients.accountTypePlatform',
  Patients_AccountTypeInstitution = 'adminPortal:patients.accountTypeInstitution',
  Patients_NoPatientFound = 'adminPortal:patients.noPatientFound',
  Pharmacies_Headline = 'adminPortal:pharmacies.headline',
  Patients_Headline = 'adminPortal:patients.headline',
  Pharmacies_Name = 'adminPortal:pharmacies.name',
  Pharmacies_Zip = 'adminPortal:pharmacies.zip',
  Pharmacies_City = 'adminPortal:pharmacies.city',
  Pharmacies_NoPharmaciesFound = 'adminPortal:pharmacies.noPharmaciesFound',
  Pharmacies_HeadlineDetail = 'adminPortal:pharmacies.headlineDetail',
  Pharmacies_HeadlineCreate = 'adminPortal:pharmacies.headlineCreate',
  Pharmacies_CreateAnother = 'adminPortal:pharmacies.createAnother',
  Pharmacies_EditData = 'adminPortal:pharmacies.editData',
  Pharmacies_Activate = 'adminPortal:pharmacies.activate',
  Pharmacies_Deactivate = 'adminPortal:pharmacies.deactivate',
  Pharmacies_StatusChangeError = 'adminPortal:pharmacies.statusChangeError',
  Pharmacies_CreationSuccess = 'adminPortal:pharmacies.creationSuccess',
  Pharmacies_CreationError = 'adminPortal:pharmacies.creationError',
  Doctors_Company = 'adminPortal:doctors.company',
  Doctors_Name = 'adminPortal:doctors.name',
  Doctors_BusinessAccountNumber = 'adminPortal:doctors.businessAccountNumber',
  Doctors_Debitor = 'adminPortal:doctors.debitor',
  Doctors_Email = 'adminPortal:doctors.email',
  Doctors_NoDocFound = 'adminPortal:doctors.noDocFound',
  Doctors_HeadlineDetail = 'adminPortal:doctors.headlineDetail',
  Doctors_Address = 'adminPortal:doctors.address',
  Doctors_SendReport = 'adminPortal:doctors.sendReport',
  Doctors_NoReport = 'adminPortal:doctors.noReport',
  Doctors_ReceivePatientReportDay1 = 'adminPortal:doctors.receivePatientReportDay1',
  Doctors_ReceivePatientReportDay2 = 'adminPortal:doctors.receivePatientReportDay2',
  Doctors_HintPatientReport = 'adminPortal:doctors.hintPatientReport',
  Doctors_EditDoctorData = 'adminPortal:doctors.editDoctorData',
  Doctors_SendTestReport = 'adminPortal:doctors.sendTestReport',
  Doctors_TextSendReport = 'adminPortal:doctors.textSendReport',
  Doctors_BtnSendReport = 'adminPortal:doctors.btnSendReport',
  Doctors_SuccesSendReport = 'adminPortal:doctors.succesSendReport',
  Doctors_ErrorSendReport = 'adminPortal:doctors.errorSendReport',
  Doctors_ErrorNoValidPrescriptions = 'adminPortal:doctors.errorNoValidPrescriptions',
  Doctors_InvalidReceiveDay1 = 'adminPortal:doctors.invalidReceiveDay1',
  Doctors_InvalidReceiveDay2 = 'adminPortal:doctors.invalidReceiveDay2',
  Docs_Headline = 'adminPortal:docs.headline',
  Docs_Search = 'adminPortal:docs.search',
  Docs_ExportWithReport = 'adminPortal:docs.exportWithReport',
  Docs_ExportLoading = 'adminPortal:docs.exportLoading',
  OpenRequests_Headline = 'adminPortal:openRequests.headline',
  OpenRequests_SortLabel = 'adminPortal:openRequests.sortLabel',
  OpenRequests_SortAscending = 'adminPortal:openRequests.sortAscending',
  OpenRequests_SortDescending = 'adminPortal:openRequests.sortDescending',
  OpenRequests_SearchButton = 'adminPortal:openRequests.searchButton',
  OpenRequests_Email = 'adminPortal:openRequests.email',
  OpenRequests_CustomerNumber = 'adminPortal:openRequests.customerNumber',
  OpenRequests_Requested = 'adminPortal:openRequests.requested',
  OpenRequests_Confirmed = 'adminPortal:openRequests.confirmed',
  OpenRequests_Done = 'adminPortal:openRequests.done',
  OpenRequests_Yes = 'adminPortal:openRequests.yes',
  OpenRequests_LoadingMessage = 'adminPortal:openRequests.loadingMessage',
  OpenRequests_NoResults = 'adminPortal:openRequests.noResults',
  OpenRequests_NoResultsForEmail = 'adminPortal:openRequests.noResultsForEmail',
  OpenRequests_InvalidEmail = 'adminPortal:openRequests.invalidEmail',
  OpenRequests_NotFound = 'adminPortal:openRequests.notFound',
  OpenRequests_EditComment = 'adminPortal:openRequests.editComment',
  FailedRequests_Headline = 'adminPortal:failedRequests.headline',
  FailedRequests_LoadingMessage = 'adminPortal:failedRequests.loadingMessage',
  FailedRequests_ErrorMessage = 'adminPortal:failedRequests.errorMessage',
  FailedRequests_Resubmit = 'adminPortal:failedRequests.resubmit',
  FailedRequests_Reset = 'adminPortal:failedRequests.reset',
  FailedRequests_EditRequest = 'adminPortal:failedRequests.editRequest',
  FailedRequests_DeleteRequest = 'adminPortal:failedRequests.deleteRequest',
  FailedRequests_DeleteModal = 'adminPortal:failedRequests.deleteModal',
  FailedRequests_InvalidJson = 'adminPortal:failedRequests.invalidJson',
  FailedRequests_Resubmitted = 'adminPortal:failedRequests.resubmitted',
  FailedRequests_Deleted = 'adminPortal:failedRequests.deleted',
  Patients_DeletedMessage = 'adminPortal:patients.deletedMessage',
  Patients_HeadlineDetail = 'adminPortal:patients.headlineDetail',
  Patients_HeadlineCumulus = 'adminPortal:patients.headlineCumulus',
  Patients_FullName = 'adminPortal:patients.fullName',
  Patients_Dob = 'adminPortal:patients.dob',
  Patients_RegistrationPromoCode = 'adminPortal:patients.registrationPromoCode',
  Patients_RegistrationOn = 'adminPortal:patients.registrationOn',
  Patients_StatusMfa = 'adminPortal:patients.statusMfa',
  Patients_Active = 'adminPortal:patients.active',
  Patients_Inactive = 'adminPortal:patients.inactive',
  Patients_InactiveMfa = 'adminPortal:patients.inactiveMfa',
  Patients_IncludeInReport = 'adminPortal:patients.includeInReport',
  Patients_ExcludeFromReport = 'adminPortal:patients.excludeFromReport',
  Patients_EditUsername = 'adminPortal:patients.editUsername',
  Patients_UsernameTaken = 'adminPortal:patients.usernameTaken',
  Patients_DeactivateAccount = 'adminPortal:patients.deactivateAccount',
  Patients_ActivateAccount = 'adminPortal:patients.activateAccount',
  Patients_LoginAsPatient = 'adminPortal:patients.loginAsPatient',
  Patients_NewPassword = 'adminPortal:patients.newPassword',
  Patients_BtnEmailSuccess = 'adminPortal:patients.btnEmailSuccess',
  Patients_TriggerRegistration = 'adminPortal:patients.triggerRegistration',
  Patients_RegisterEmailSent = 'adminPortal:patients.registerEmailSent',
  Patients_DeleteAccount = 'adminPortal:patients.deleteAccount',
  Patients_DeactivateMfa = 'adminPortal:patients.deactivateMfa',
  Patients_BtnSendEmail = 'adminPortal:patients.btnSendEmail',
  Patients_RegisterOverlayHeadline = 'adminPortal:patients.registerOverlayHeadline',
  Patients_DeleteModal = 'adminPortal:patients.deleteModal',
  Patients_TextSendEmail = 'adminPortal:patients.textSendEmail',
  Patients_SuccessEmailSent = 'adminPortal:patients.successEmailSent',
  Patients_ErrorEmailSent = 'adminPortal:patients.errorEmailSent',
  Patients_RegisterEmailSentInfo = 'adminPortal:patients.registerEmailSentInfo',
  Patients_RegistrationNotPossibleNoEmail = 'adminPortal:patients.registrationNotPossibleNoEmail',
  Patients_RegistrationAlreadyTriggered = 'adminPortal:patients.registrationAlreadyTriggered',
  Patients_RegistrationError = 'adminPortal:patients.registrationError',
  Patients_Cancel = 'adminPortal:patients.cancel',
  Patients_Save = 'adminPortal:patients.save',
  Cumulus_ActiveCumulusNumber = 'adminPortal:cumulus.activeCumulusNumber',
  Cumulus_AddCumulusNumber = 'adminPortal:cumulus.addCumulusNumber',
  Cumulus_LastCumulusUpdate = 'adminPortal:cumulus.lastCumulusUpdate',
  Cumulus_DeleteOverlayTitle = 'adminPortal:cumulus.deleteOverlayTitle',
  Cumulus_TableHeadline = 'adminPortal:cumulus.tableHeadline',
  Cumulus_TableOravaOrderId = 'adminPortal:cumulus.tableOravaOrderId',
  Cumulus_TablePrescriptionId = 'adminPortal:cumulus.tablePrescriptionId',
  Cumulus_TableCumulusPoints = 'adminPortal:cumulus.tableCumulusPoints',
  Cumulus_TableConfirmationDate = 'adminPortal:cumulus.tableConfirmationDate',
  Cumulus_Delete = 'adminPortal:cumulus.delete',
  Cumulus_ServerError = 'adminPortal:cumulus.serverError',
  Cumulus_NoCumulusPoints = 'adminPortal:cumulus.noCumulusPoints',
  PickPost_Headline = 'adminPortal:pickPost.headline',
  PickPost_SelectFile = 'adminPortal:pickPost.selectFile',
  PickPost_DropzoneTitle = 'adminPortal:pickPost.dropzoneTitle',
  PickPost_Upload = 'adminPortal:pickPost.upload',
  PickPost_UploadSuccess = 'adminPortal:pickPost.uploadSuccess',
  PickPost_UploadError = 'adminPortal:pickPost.uploadError',
  PickPost_Export = 'adminPortal:pickPost.export',
  PickPost_ExportSuccess = 'adminPortal:pickPost.exportSuccess',
  PickPost_ExportError = 'adminPortal:pickPost.exportError',
  PickPost_New = 'adminPortal:pickPost.new',
  PickPost_Changed = 'adminPortal:pickPost.changed',
  PickPost_PickPostId = 'adminPortal:pickPost.pickPostId',
  PickPost_Street = 'adminPortal:pickPost.street',
  PickPost_Link = 'adminPortal:pickPost.link',
  PickPost_Details = 'adminPortal:pickPost.details',
  PickPost_WhitelistStatus = 'adminPortal:pickPost.whitelistStatus',
  PickPost_WhitelistUpdated = 'adminPortal:pickPost.whitelistUpdated',
  PickPost_WhitelistError = 'adminPortal:pickPost.whitelistError',
  PickPost_NoNewPickPosts = 'adminPortal:pickPost.noNewPickPosts',
  PickPost_LoadingMessage = 'adminPortal:pickPost.loadingMessage',
  PickPostView_Headline = 'adminPortal:pickPostView.headline',
  PickPostView_SearchLabel = 'adminPortal:pickPostView.searchLabel',
  PickPostView_SearchInfo = 'adminPortal:pickPostView.searchInfo',
  PickPostView_Search = 'adminPortal:pickPostView.search',
  PickPostView_FilterLabel = 'adminPortal:pickPostView.filterLabel',
  PickPostView_FilterAll = 'adminPortal:pickPostView.filterAll',
  PickPostView_FilterWhitelistTrue = 'adminPortal:pickPostView.filterWhitelistTrue',
  PickPostView_FilterWhitelistFalse = 'adminPortal:pickPostView.filterWhitelistFalse',
  PickPostView_FilterNewOrChanged = 'adminPortal:pickPostView.filterNewOrChanged',
  PickPostView_WhitelistStatusReadOnly = 'adminPortal:pickPostView.whitelistStatusReadOnly',
  PickPostView_NoPickPostsFound = 'adminPortal:pickPostView.noPickPostsFound',
  Header_Claim = 'adminPortal:header.claim',
}
type AdminPortalKey =
  | 'maintenance.headline'
  | 'maintenance.switch'
  | 'backToOverview'
  | 'backToList'
  | 'activationMaintenancePageOverlay.title'
  | 'activationMaintenancePageOverlay.description'
  | 'activationMaintenancePageOverlay.btnActivate'
  | 'navigation.menu'
  | 'navigation.logout'
  | 'navigation.welcome'
  | 'navigation.pharmacies'
  | 'navigation.patients'
  | 'navigation.doctors'
  | 'navigation.openRequests'
  | 'navigation.failedRequests'
  | 'navigation.promotions'
  | 'navigation.pickPost'
  | 'navigation.pickPostView'
  | 'navigation.maintenance'
  | 'navigation.profile'
  | 'pagination.label'
  | 'pagination.previousPage'
  | 'pagination.nextPage'
  | 'pagination.loading'
  | 'header.logoAlt'
  | 'footer.copyright'
  | 'welcome.headline'
  | 'welcome.pickPostAdministration'
  | 'welcome.patientAdministration'
  | 'welcome.doctorsAdministration'
  | 'promotions.promotionCode'
  | 'promotions.promotionName'
  | 'promotions.promotionValidFrom'
  | 'promotions.promotionValidUntil'
  | 'promotions.promotionFullfillUntil'
  | 'promotions.mediaCode'
  | 'promotions.filterActive'
  | 'promotions.filterComing'
  | 'promotions.filterExpired'
  | 'promotions.createNew'
  | 'promotions.noResults'
  | 'promotions.noResultsForFilter'
  | 'promotions.lastExport'
  | 'promotions.exportButton'
  | 'promotions.exportConfirmText'
  | 'promotions.exportConfirmButton'
  | 'promotions.exportNoData'
  | 'promotions.headline'
  | 'promotions.headlineCreate'
  | 'promotions.loadingDetail'
  | 'promotions.notFound'
  | 'promotions.validFromDate'
  | 'promotions.validFromTime'
  | 'promotions.validUntilDate'
  | 'promotions.validUntilTime'
  | 'promotions.fulfillUntilDate'
  | 'promotions.fulfillUntilTime'
  | 'promotions.voucherValue'
  | 'promotions.errorCheckInput'
  | 'promotions.activeEditNotice'
  | 'promotions.expiredNotice'
  | 'promotions.validFromNotInPast'
  | 'promotions.validUntilAfterValidFrom'
  | 'promotions.fulfillUntilAfterValidUntil'
  | 'promotions.created'
  | 'welcome.promotionAdministration'
  | 'profile.headline'
  | 'login.info'
  | 'login.genericError'
  | 'login.formHeadline'
  | 'login.loginButton'
  | 'login.errorEmptyForm'
  | 'login.invalidCredentials'
  | 'login.serverError'
  | 'login.logoutSuccess'
  | 'login.sessionTimeoutSuccess'
  | 'login.pageClaim'
  | 'patients.invalidCustomerId'
  | 'patients.invalidEmail'
  | 'patients.invalidUsername'
  | 'patients.invalidCardId'
  | 'patients.filterLean'
  | 'patients.filterLeanMediplus'
  | 'patients.filterKpt'
  | 'patients.filterRx'
  | 'patients.search'
  | 'patients.customerType'
  | 'patients.accountTypePlatform'
  | 'patients.accountTypeInstitution'
  | 'patients.noPatientFound'
  | 'pharmacies.headline'
  | 'patients.headline'
  | 'pharmacies.name'
  | 'pharmacies.zip'
  | 'pharmacies.city'
  | 'pharmacies.noPharmaciesFound'
  | 'pharmacies.headlineDetail'
  | 'pharmacies.headlineCreate'
  | 'pharmacies.createAnother'
  | 'pharmacies.editData'
  | 'pharmacies.activate'
  | 'pharmacies.deactivate'
  | 'pharmacies.statusChangeError'
  | 'pharmacies.creationSuccess'
  | 'pharmacies.creationError'
  | 'doctors.company'
  | 'doctors.name'
  | 'doctors.businessAccountNumber'
  | 'doctors.debitor'
  | 'doctors.email'
  | 'doctors.noDocFound'
  | 'doctors.headlineDetail'
  | 'doctors.address'
  | 'doctors.sendReport'
  | 'doctors.noReport'
  | 'doctors.receivePatientReportDay1'
  | 'doctors.receivePatientReportDay2'
  | 'doctors.hintPatientReport'
  | 'doctors.editDoctorData'
  | 'doctors.sendTestReport'
  | 'doctors.textSendReport'
  | 'doctors.btnSendReport'
  | 'doctors.succesSendReport'
  | 'doctors.errorSendReport'
  | 'doctors.errorNoValidPrescriptions'
  | 'doctors.invalidReceiveDay1'
  | 'doctors.invalidReceiveDay2'
  | 'docs.headline'
  | 'docs.search'
  | 'docs.exportWithReport'
  | 'docs.exportLoading'
  | 'openRequests.headline'
  | 'openRequests.sortLabel'
  | 'openRequests.sortAscending'
  | 'openRequests.sortDescending'
  | 'openRequests.searchButton'
  | 'openRequests.email'
  | 'openRequests.customerNumber'
  | 'openRequests.requested'
  | 'openRequests.confirmed'
  | 'openRequests.done'
  | 'openRequests.yes'
  | 'openRequests.loadingMessage'
  | 'openRequests.noResults'
  | 'openRequests.noResultsForEmail'
  | 'openRequests.invalidEmail'
  | 'openRequests.notFound'
  | 'openRequests.editComment'
  | 'failedRequests.headline'
  | 'failedRequests.loadingMessage'
  | 'failedRequests.errorMessage'
  | 'failedRequests.resubmit'
  | 'failedRequests.reset'
  | 'failedRequests.editRequest'
  | 'failedRequests.deleteRequest'
  | 'failedRequests.deleteModal'
  | 'failedRequests.invalidJson'
  | 'failedRequests.resubmitted'
  | 'failedRequests.deleted'
  | 'patients.deletedMessage'
  | 'patients.headlineDetail'
  | 'patients.headlineCumulus'
  | 'patients.fullName'
  | 'patients.dob'
  | 'patients.registrationPromoCode'
  | 'patients.registrationOn'
  | 'patients.statusMfa'
  | 'patients.active'
  | 'patients.inactive'
  | 'patients.inactiveMfa'
  | 'patients.includeInReport'
  | 'patients.excludeFromReport'
  | 'patients.editUsername'
  | 'patients.usernameTaken'
  | 'patients.deactivateAccount'
  | 'patients.activateAccount'
  | 'patients.loginAsPatient'
  | 'patients.newPassword'
  | 'patients.btnEmailSuccess'
  | 'patients.triggerRegistration'
  | 'patients.registerEmailSent'
  | 'patients.deleteAccount'
  | 'patients.deactivateMfa'
  | 'patients.btnSendEmail'
  | 'patients.registerOverlayHeadline'
  | 'patients.deleteModal'
  | 'patients.textSendEmail'
  | 'patients.successEmailSent'
  | 'patients.errorEmailSent'
  | 'patients.registerEmailSentInfo'
  | 'patients.registrationNotPossibleNoEmail'
  | 'patients.registrationAlreadyTriggered'
  | 'patients.registrationError'
  | 'patients.cancel'
  | 'patients.save'
  | 'cumulus.activeCumulusNumber'
  | 'cumulus.addCumulusNumber'
  | 'cumulus.lastCumulusUpdate'
  | 'cumulus.deleteOverlayTitle'
  | 'cumulus.tableHeadline'
  | 'cumulus.tableOravaOrderId'
  | 'cumulus.tablePrescriptionId'
  | 'cumulus.tableCumulusPoints'
  | 'cumulus.tableConfirmationDate'
  | 'cumulus.delete'
  | 'cumulus.serverError'
  | 'cumulus.noCumulusPoints'
  | 'pickPost.headline'
  | 'pickPost.selectFile'
  | 'pickPost.dropzoneTitle'
  | 'pickPost.upload'
  | 'pickPost.uploadSuccess'
  | 'pickPost.uploadError'
  | 'pickPost.export'
  | 'pickPost.exportSuccess'
  | 'pickPost.exportError'
  | 'pickPost.new'
  | 'pickPost.changed'
  | 'pickPost.pickPostId'
  | 'pickPost.street'
  | 'pickPost.link'
  | 'pickPost.details'
  | 'pickPost.whitelistStatus'
  | 'pickPost.whitelistUpdated'
  | 'pickPost.whitelistError'
  | 'pickPost.noNewPickPosts'
  | 'pickPost.loadingMessage'
  | 'pickPostView.headline'
  | 'pickPostView.searchLabel'
  | 'pickPostView.searchInfo'
  | 'pickPostView.search'
  | 'pickPostView.filterLabel'
  | 'pickPostView.filterAll'
  | 'pickPostView.filterWhitelistTrue'
  | 'pickPostView.filterWhitelistFalse'
  | 'pickPostView.filterNewOrChanged'
  | 'pickPostView.whitelistStatusReadOnly'
  | 'pickPostView.noPickPostsFound'
  | 'header.claim';

export { AdminPortalKeys, type AdminPortalKey };
